import "../../style/components/Markdown.scss";

import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useSelector, useDispatch } from "react-redux";

import { setModalVisibility } from "../actions";
import { modalVisibilitySelector, modeNameSelector } from "../selectors";

const HelpModal = () => {
  const modalVisibility = useSelector(modalVisibilitySelector);
  const modeName = useSelector(modeNameSelector);

  const dispatch = useDispatch();

  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    const invalidModes = [
      "subpage",
      "calc-",
      "premium",
      "movedetail",
      "versionlogs",
    ];

    if (!modeName || invalidModes.some(m => modeName.startsWith(m))) return;

    const loadMarkdown = async () => {
      try {
        const file = await import(`../constants/helpfiles/${modeName}.md`);
        const response = await fetch(file.default);
        const text = await response.text();
        setMarkdown(text);
      } catch {
        setMarkdown("Whoops");
      }
    };

    loadMarkdown();
  }, [modeName]);

  return (
    <IonModal
      isOpen={modalVisibility.visible && modalVisibility.currentModal === "help"}
      onDidDismiss={ () => modalVisibility.visible && dispatch(setModalVisibility({ currentModal: "help", visible: false })) }
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={() => dispatch(setModalVisibility({ currentModal: "help", visible: false }))}>Close</IonButton>
          </IonButtons>
          <IonTitle>Help</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent id="Help">
        <div id="MarkdownContainer">
          <ReactMarkdown children={markdown} />
        </div>
      </IonContent>
    </IonModal>
  );
};

export default HelpModal;
